var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var config = {
    counter: 0,
    services: [],
};
export function metadataOf(target) {
    return target.__metadata__ || {};
}
export function metadata(target, value) {
    Object.defineProperty(target, '__metadata__', {
        configurable: true,
        enumerable: false,
        writable: false,
        value: __assign(__assign({}, metadataOf(target)), value)
    });
}
